<app-breadcrumb [title]="'Documentos Plan de Preparación'" [items]="['Pesv']"
    [active_item]="'Documentos Plan de Preparación'"></app-breadcrumb>
<div class="container-fluid">
    <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-file-document me-2"></i>
      <h5 class="mb-0"><strong>DOCUMENTOS PLAN DE PREPARACIÓN</strong></h5>
    </div>

    <div class="card-body">
      <div class="col-sm-12 col-xl-12">
        <div class="card-body p-2 p-md-3">
          <div class="card card-absolute rounded">
            <div class="card-header bg-primary d-flex justify-content-between align-items-center">
              <h5 class="text-white mb-0"><strong>HISTORIAL DE DOCUMENTOS PLAN DE PREPARACIÓN</strong></h5>
            </div>


                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-sm-12 col-md-3 ms-auto">
                                    <div class="input-group">
                                        <input type="text" class="form-control"
                                            placeholder="Buscar por código, versión, fecha o estado"
                                            [value]="searchText"
                                            (input)="searchText = $any($event.target).value; aplicarFiltro()" />
                                        <span class="input-group-text">
                                            <i class="fa fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="table-responsive my-4">
                                <table class="table table-hover table-bordered" id="tblPlanPreparacionRespuesta">
                                    <thead class="bg-primary">
                                        <tr>
                                            <th class="text-center"><strong>CODIGO</strong></th>
                                            <th class="text-center"><strong>VERSIÓN</strong></th>
                                            <th class="text-center"><strong>DESIGNACIÓN</strong></th>
                                            <th class="text-center"><strong>VENCIMIENTO</strong></th>
                                            <th class="text-center"><strong>ESTADO</strong></th>
                                            <th class="text-center"><strong>ACCIONES</strong></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr
                                            *ngFor="let item of historialVista | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                                            <td class="text-center">{{ item.codigo }}</td>
                                            <td class="text-center">{{ item.version }}</td>
                                            <td class="text-center">{{ formatDateTodo(item.fecha_designacion) }}</td>
                                            <td class="text-center">{{ formatDateTodo(item.fecha_vencimiento) }}</td>
                                            <td class="text-center">
                                                <span class="badge"
                                                    [ngClass]="esActivo(item) ? 'bg-success' : 'bg-danger'">
                                                    {{ esActivo(item) ? 'ACTIVO' : 'INACTIVO' }}
                                                </span>
                                            </td>
                                            <td class="text-center">
                                                <div class="d-flex justify-content-center gap-1">
                                                    <button
                                                        class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                                        *ngIf="puedeEditar(item)" ngbTooltip="Editar"
                                                        (click)="editarDesdeHistorial(item); abrirModalEditar(modalEditar)">
                                                        <i class="icon-pencil-alt" style="font-size: .85rem;"></i>
                                                    </button>

                                                    <button
                                                        class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                                        *ngIf="esActivo(item)" ngbTooltip="Inactivar"
                                                        (click)="cambiarEstado(item, false)">
                                                        <i class="icon-close" style="font-size: .85rem;"></i>
                                                    </button>

                                                    <button class="btn btn-sm btn-outline-info rounded-pill btn-rounded"
                                                        ngbTooltip="Previsualizar" (click)="visualizarPDF(item)">
                                                        <span *ngIf="!descargando"><i class="icon-eye"
                                                                style="font-size: .85rem;"></i></span>
                                                        <span *ngIf="descargando"><span
                                                                class="spinner-border spinner-border-sm" role="status"
                                                                aria-hidden="true"></span></span>
                                                    </button>

                                                    <button
                                                        class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                                        ngbTooltip="Descargar" (click)="descargarDocumento(item)">
                                                        <span *ngIf="!descargando"><i class="icon-download"
                                                                style="font-size: .85rem;"></i></span>
                                                        <span *ngIf="descargando"><span
                                                                class="spinner-border spinner-border-sm" role="status"
                                                                aria-hidden="true"></span></span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="d-flex justify-content-between align-items-center mt-4">
                                <div class="d-flex align-items-center">
                                    <label for="pageSizePlanPreparacion" class="me-2">Mostrar:</label>
                                    <select id="pageSizePlanPreparacion" class="form-select w-auto"
                                        [(ngModel)]="pageSize1" (change)="page1 = 1">
                                        <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}
                                        </option>
                                    </select>
                                    <span class="ms-2">registros por página</span>
                                </div>

                                <div class="text-center flex-grow-1">
                                    Total Registros:
                                    <a class="badge badge-primary"><b>{{ historialVista.length }}</b></a>
                                </div>

                                <div class="text-end paginador-personalizado">
                                    <pagination-controls (pageChange)="page1 = $event" [maxSize]="5"
                                        [directionLinks]="true" [autoHide]="true" previousLabel="Anterior"
                                        nextLabel="Siguiente">
                                    </pagination-controls>
                                </div>
                            </div>

                            <div class="mt-4">
                                <div class="btn-showcase text-center">
                                    <button class="btn btn-outline-success-2x" type="button" placement="top"
                                        ngbTooltip="Exportar a Excel" (click)="exportarExcel()">
                                        <i class="icofont icofont-file-excel"></i> EXCEL
                                    </button>

                                    <button class="btn btn-outline-danger-2x" type="button" placement="top"
                                        ngbTooltip="Exportar a PDF" (click)="exportarPdf()">
                                        <i class="icofont icofont-file-pdf"></i> PDF
                                    </button>

                                    <button class="btn btn-outline-primary-2x" type="button" placement="top"
                                        [disabled]="tieneVigente"
                                        [ngbTooltip]="tieneVigente ? 'Ya existe un plan vigente. No se puede crear otro.' : 'Crear plan'"
                                        (click)="abrirModalCrear()">
                                        <i class="icofont icofont-file-pdf"></i> CREAR PLAN
                                    </button>
                                </div>
                            </div>

                            <div *ngIf="tieneVigente" class="alert alert-warning py-2 mb-0 mt-3" role="alert">
                                Ya existe un Plan de Preparación y Respuesta vigente. Debe inactivar el actual o esperar
                                a que venza para crear uno nuevo.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal Crear -->
<ng-template #modalCrear let-modal>
    <div class="modal-header bg-primary text-white">
        <div>
            <h5 class="modal-title d-flex align-items-center gap-2 mb-1">
                <i class="icofont icofont-file-document"></i>
                Crear Plan de Preparación y Respuesta
            </h5>
            <p class="mb-0 small opacity-75">Complete los datos principales y adjunte el documento PDF.</p>
        </div>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
        <form [formGroup]="formCrear">
            <div class="card border-0 shadow-sm mb-3">
                <div class="card-body">
                    <h6 class="fw-bold text-primary mb-3">
                        <i class="icofont icofont-info-circle me-2"></i>
                        Información general
                    </h6>

                    <div class="row g-3">
                        <div class="col-md-6">
                            <label class="form-label text-dark fw-semibold">Código <span
                                    class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="codigo"
                                placeholder="PESV-PLAN-PREP-001" />
                            <small class="text-secondary fw-medium">Ingrese un identificador único para el plan.</small>
                        </div>

                        <div class="col-md-6">
                            <label class="form-label text-dark fw-semibold">Versión <span
                                    class="text-danger">*</span></label>
                            <input class="form-control" formControlName="version" placeholder="1.0" />
                        </div>

                        <div class="col-md-6">
                            <label class="form-label text-dark fw-semibold">Fecha creación <span
                                    class="text-danger">*</span></label>
                            <input type="date" class="form-control" formControlName="fecha_designacion" [attr.max]="hoy"
                                onkeydown="return false" />
                        </div>

                        <div class="col-md-6">
                            <label class="form-label text-dark fw-semibold">Fecha vencimiento <span
                                    class="text-danger">*</span></label>
                            <input type="date" class="form-control" formControlName="fecha_vencimiento" [attr.min]="hoy"
                                onkeydown="return false" />
                        </div>

                        <div class="col-md-12">
                            <label class="form-label text-dark fw-semibold">Estado <span
                                    class="text-danger">*</span></label>
                            <select class="form-select" formControlName="estado">
                                <option *ngFor="let estado of estadosDocumento" [value]="estado.id">{{ estado.nombre }}
                                </option>
                            </select>
                        </div>

                        <div class="col-md-12">
                            <label class="form-label text-dark fw-semibold">Motivo de creación o cambio <span
                                    class="text-danger">*</span></label>
                            <textarea class="form-control" rows="3" formControlName="motivo_creacion"
                                placeholder="Ej. Renovación por vencimiento del plan anterior o actualización normativa"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card border-0 shadow-sm">
                <div class="card-body">
                    <h6 class="fw-bold text-primary mb-3">
                        <i class="icofont icofont-file-pdf me-2"></i>
                        Plan de Preparación y Respuesta - Documento PDF
                    </h6>

                    <input type="file" class="d-none" id="fileInputPlanPreparacionPdf" accept=".pdf"
                        (change)="onPdfFileSelected($event)" />

                    <label for="fileInputPlanPreparacionPdf"
                        class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary border-2 rounded-3 cursor-pointer bg-light"
                        tabindex="0" (dragover)="onDragOverPdf($event)" (dragleave)="onDragLeavePdf($event)"
                        (drop)="onDropPdf($event)">
                        <ng-container *ngIf="pdfFileSelected; else noFilePdf">
                            <i class="icofont icofont-file-pdf fs-1 text-danger mb-2"></i>
                            <div class="text-center">
                                <div class="fw-bold text-primary">{{ pdfFileSelected?.name }}</div>
                                <small class="text-secondary fw-medium">{{ formatFileSize(pdfFileSelected.size)
                                    }}</small>
                            </div>
                        </ng-container>

                        <ng-template #noFilePdf>
                            <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>
                            <h6 class="mb-1 text-primary">Cargar PDF</h6>
                            <small class="text-dark">Arrastre el archivo aquí o haga clic para seleccionarlo</small>
                        </ng-template>
                    </label>

                    <div *ngIf="pdfFileSelected" class="d-flex justify-content-center mt-3">
                        <button class="btn btn-outline-danger px-4" type="button" (click)="removePdfSeleccionado()">
                            <i class="icofont icofont-trash me-2"></i>
                            Eliminar archivo
                        </button>
                    </div>

                    <small class="text-secondary fw-medium d-block mt-2"> Solo se permite archivo PDF con un tamaño
                        máximo de 10 MB. </small>
                </div>
            </div>
        </form>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
            <i class="icofont icofont-close me-1"></i>
            Cancelar
        </button>

        <button type="button" class="btn btn-primary" [disabled]="formCrear.invalid" (click)="guardar()">
            <i class="icofont icofont-save me-1"></i>
            Guardar Plan
        </button>
    </div>
</ng-template>

<!-- Modal Editar -->
<ng-template #modalEditar let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">Editar Plan de Preparación y Respuesta</h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
        <form [formGroup]="formEditar">
            <div class="row g-3 mb-3">
                <div class="col-12 col-md-4">
                    <label class="form-label text-dark fw-bold">Código: <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" placeholder="Ej: PESV-PLAN-PREP-001"
                        formControlName="codigo"
                        [class.is-invalid]="formEditar.get('codigo')?.invalid && formEditar.get('codigo')?.touched" />
                    <div class="invalid-feedback">El código es obligatorio.</div>
                </div>

                <div class="col-12 col-md-4">
                    <label class="form-label text-dark fw-bold">Fecha designación: <span
                            class="text-danger">*</span></label>
                    <input type="date" class="form-control" formControlName="fecha_designacion"
                        [class.is-invalid]="formEditar.get('fecha_designacion')?.invalid && formEditar.get('fecha_designacion')?.touched" />
                    <div class="invalid-feedback">La fecha de designación es obligatoria.</div>
                </div>

                <div class="col-12 col-md-4">
                    <label class="form-label text-dark fw-bold">Fecha vencimiento: <span
                            class="text-danger">*</span></label>
                    <input type="date" class="form-control" formControlName="fecha_vencimiento"
                        [class.is-invalid]="formEditar.get('fecha_vencimiento')?.invalid && formEditar.get('fecha_vencimiento')?.touched" />
                    <div class="invalid-feedback">La fecha de vencimiento es obligatoria.</div>
                </div>

                <div class="col-12 col-md-12">
                    <label class="form-label text-dark fw-bold">Estado: <span class="text-danger">*</span></label>
                    <select class="form-select" formControlName="estado">
                        <option *ngFor="let estado of estadosDocumento" [value]="estado.id">{{ estado.nombre }}</option>
                    </select>
                </div>
            </div>

            <div class="card card-absolute rounded mt-4">
                <div class="card-body">
                    <label class="form-label text-dark fw-bold">Reemplazar documento</label>
                    <input type="file" class="form-control" accept=".pdf" (change)="onFileChangeEditar($event)" />

                    <div *ngIf="archivoSeleccionadoEditar" class="archivo-info p-3 bg-light rounded mt-3">
                        <div class="d-flex align-items-start mb-3">
                            <i class="icofont icofont-file-document text-primary me-3" style="font-size: 32px"></i>
                            <div class="flex-grow-1">
                                <strong>{{ archivoSeleccionadoEditar.name }}</strong>
                                <div class="small text-secondary fw-medium">Tamaño: {{ (archivoSeleccionadoEditar.size /
                                    1024).toFixed(2) }} KB</div>
                            </div>
                        </div>

                        <div class="d-flex gap-2">
                            <button type="button" class="btn btn-danger flex-grow-1" (click)="eliminarArchivoEditar()">
                                <i class="icofont icofont-trash"></i> Eliminar archivo seleccionado
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="guardarCambios(modal)" [disabled]="cargandoEditar">
            <span *ngIf="!cargandoEditar"> <i class="icofont icofont-save me-1"></i>Guardar Cambios </span>
            <span *ngIf="cargandoEditar">
                <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Guardando...
            </span>
        </button>
    </div>
</ng-template>

<!-- Modal Visualizar -->
<ng-template #modalVisualizar let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">Previsualizar Documento</h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
        <div *ngIf="pdfUrl; else cargandoPreview">
            <div style="width: 100%; height: 75vh">
                <iframe [src]="pdfUrl" width="100%" height="100%" style="border: 0"></iframe>
            </div>
        </div>
        <ng-template #cargandoPreview>
            <div class="text-center py-5">
                <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Cargando...</span>
                </div>
                <p class="mt-2">Cargando documento...</p>
            </div>
        </ng-template>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
    </div>
</ng-template>